import React, { useState } from 'react';
import { extractErrorMessage } from '../lib/errors';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import GoogleAuthButton from '../components/GoogleAuthButton';

export default function Signup() {
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { signup } = useAuth();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(form.name, form.email, form.password);
      toast.success('Welcome to Reachly!');
      nav('/app');
    } catch (err) {
      toast.error(extractErrorMessage(err, 'Signup failed'));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0b] flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-9 h-9 rounded-full border border-[#d4a94a] flex items-center justify-center">
            <span className="font-display text-[#d4a94a] text-xl font-semibold leading-none">R</span>
          </div>
          <span className="font-display text-2xl text-zinc-100">Reachly</span>
        </Link>
        <Card className="bg-[#111110] border-zinc-900 p-8">
          <h1 className="font-display text-2xl text-zinc-100">Land your next role.</h1>
          <p className="text-sm text-zinc-500 mt-1">Free forever. No credit card required.</p>
          <div className="mt-6">
            <GoogleAuthButton intent="signup" testid="signup-google-btn"/>
            <div className="mt-6 flex items-center gap-3 text-[11px] uppercase tracking-widest text-zinc-600">
              <div className="h-px flex-1 bg-zinc-900"/>
              or with email
              <div className="h-px flex-1 bg-zinc-900"/>
            </div>
          </div>
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <div>
              <Label className="text-zinc-300">Full name</Label>
              <Input required value={form.name} onChange={e=>setForm({...form, name:e.target.value})} className="mt-1.5 bg-[#0a0a0b] border-zinc-800 text-zinc-100 focus-visible:ring-[#d4a94a]" placeholder="Alex Morgan"/>
            </div>
            <div>
              <Label className="text-zinc-300">Work email</Label>
              <Input type="email" required value={form.email} onChange={e=>setForm({...form, email:e.target.value})} className="mt-1.5 bg-[#0a0a0b] border-zinc-800 text-zinc-100 focus-visible:ring-[#d4a94a]" placeholder="you@example.com"/>
            </div>
            <div>
              <Label className="text-zinc-300">Password</Label>
              <Input type="password" required minLength={6} value={form.password} onChange={e=>setForm({...form, password:e.target.value})} className="mt-1.5 bg-[#0a0a0b] border-zinc-800 text-zinc-100 focus-visible:ring-[#d4a94a]" placeholder="At least 6 characters"/>
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[#d4a94a] hover:bg-[#e5bb5c] text-black font-medium">
              {loading ? 'Creating account…' : 'Create account'}
            </Button>
          </form>
          <div className="mt-6 text-sm text-zinc-500 text-center">
            Already have an account? <Link to="/login" className="text-[#f5d67a] hover:underline">Sign in</Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
